// @flow
import React, { Component } from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import { STATUS_LOADING, STATUS_DEFAULT, STATUS_UNKNOWN, STATUS_SUCCESS } from 'constants/statusConstants';
import Loading from 'components/fragments/Loading';
import PageNotFound from 'components/app/PageNotFound';
import type { Match } from 'react-router-dom';
import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';
import type { RouterHistory } from 'react-router-dom';

export type OwnProps = {
  location: {
    pathname: string,
    search: string,
  }
};

export type DispatchProps = {
  fetchPageDetail: (slug: string) => void,
  fetchPageDetailPreview: (id: number) => void,
};

export type StateProps = {
  status: Status,
  statusPreview: Status,
  title: string,
  content: BlocContent[],
  meta_description: string,
  meta_title: string,
  template: string,
  redirection: string,
};

type HistoryProps = {
  history: RouterHistory
};

type Props = {
  pageSlug: string,
  match: Match
} & OwnProps & DispatchProps &
  StateProps & HistoryProps;

type State = {
  currentPage: string,
};

class PageDetail extends Component<Props, State> {
  _pageContent: ?HTMLElement;
  props: Props;

  componentDidMount() {
  	/**
  	 * On peut être en mode prévisualisation, le tester
  	 */
    const splits = this.props.location.pathname.split('/');
    if (/page_/.test( splits[splits.length - 1])) {
      const id = splits[splits.length - 1].replace('page_', '');
      this.props.fetchPageDetailPreview(parseInt(id, 10));
    } else {
      this.props.fetchPageDetail(this.props.pageSlug);
    }
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    if (nextState !== this.state) {
      return true;
    }
    else if (nextProps !== this.props) {
      if (nextProps.location.search !== this.props.location.search) {
        return false;
      }
      return true;
    }
    return false;
  }

  renderDetail = () => {
    const { content } = this.props;
    return content.map((blocFigure, index) => {
      return <ContentBloc key={index} {...blocFigure} />;
    });
  };

  render() {
    const {
      status,
      statusPreview,
      template,
    } = this.props;

    if (statusPreview !== STATUS_SUCCESS && (status === STATUS_LOADING || status === STATUS_DEFAULT)) {
      return <Loading isWhite />;
    }
    if (status === STATUS_UNKNOWN) {
      return <PageNotFound />;
    }

    switch (template) {
      default:
        return (
          <div className="page" ref={(r) => this._pageContent = r}>
            {this.renderDetail()}
          </div>
        );
    }
  }
}

export default withHelmet(PageDetail)((Helmet, pageProps) => {
  const description = pageProps.meta_description ? `${pageProps.meta_description.slice(0, 197)}...` : '';

  return (
    <Helmet>
      <title>{pageProps.meta_title}</title>
      <meta name={'description'} content={description} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={pageProps.meta_title} />
      <meta property={'og:description'} content={description} />
    </Helmet>
  );
});
